module.exports = __webpack_public_path__ + "static/media/pond farm 3.66517920.jpg";